
import { useQueryBuilder } from "./useBuilders";
import { FETCH, PRODUCT_TOURS } from "./queryKeys";
import { productTourApi } from "src/services/productTour";

export const useProductToursFetch= () => {
  return useQueryBuilder([PRODUCT_TOURS, FETCH], productTourApi.fetchProductTours);
}